import { useState, useCallback, useEffect } from 'react';
import { DropdownLinksApi } from './headerDropdownMenuApi';

export const useGetDropdownLinks = () => {
    const [dropdownLinksInfo, setDropdownLinksInfo] = useState(null);
    const [profileInitials, setProfileInitials] = useState('');

    const getDropdownLinks = useCallback(async () => {
        const result = await DropdownLinksApi.getDropdownLinks();

        if (result){
            setDropdownLinksInfo(result.data.listAvailablePages);

            if(result.data.profileInitials){
                window.localStorage.setItem('UI', result.data.profileInitials);
                setProfileInitials(result.data.profileInitials);
            }
        }

        if (result.error){
            return { error: result.error };
        }
    }, []);

    useEffect(() => {
        getDropdownLinks();
    }, [getDropdownLinks]);

    return { dropdownLinksInfo, profileInitials };
};